import { render, staticRenderFns } from "./SettingsRoleNewView.vue?vue&type=template&id=b04e0416&scoped=true&"
import script from "./SettingsRoleNewView.vue?vue&type=script&lang=js&"
export * from "./SettingsRoleNewView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b04e0416",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/srv/dev/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b04e0416')) {
      api.createRecord('b04e0416', component.options)
    } else {
      api.reload('b04e0416', component.options)
    }
    module.hot.accept("./SettingsRoleNewView.vue?vue&type=template&id=b04e0416&scoped=true&", function () {
      api.rerender('b04e0416', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/settings/role/SettingsRoleNewView.vue"
export default component.exports